/**
 * EasySell aux couleurs NAYLUME.
 * EasySell écrit ses couleurs en style « !important » dans ses balises et peut
 * les réécrire : on réapplique le style de la marque à chaque changement.
 * Ne fait rien si l'application n'est pas active.
 */
(() => {
  const set = (el, property, value) => {
    if (el.style.getPropertyValue(property) !== value || el.style.getPropertyPriority(property) !== 'important') {
      el.style.setProperty(property, value, 'important');
    }
  };

  const PILL = {
    background: 'var(--color-accent)',
    color: 'var(--color-dark)',
    'border-radius': '999px',
    'border-width': '0px',
    'font-weight': '700',
  };

  const darkText = (root) => {
    root.querySelectorAll('span, i').forEach((el) => {
      if (!el.classList.contains('es-loading-mask')) set(el, 'color', 'var(--color-dark)');
    });
  };

  // Réapplique `apply` maintenant et chaque fois qu'EasySell modifie l'élément
  const keep = (el, apply) => {
    apply();
    if (el.dataset.nlStyled) return;
    el.dataset.nlStyled = 'true';
    new MutationObserver(apply).observe(el, { attributes: true, attributeFilter: ['style'], childList: true, subtree: true });
  };

  // Bouton « Commander » inséré par EasySell dans le formulaire produit
  const styleButton = (button) => {
    keep(button, () => {
      Object.entries(PILL).forEach(([p, v]) => set(button, p, v));
      darkText(button);
      button.classList.add('nl-es');
    });
    const form = button.closest('.product__form');
    if (form) form.classList.add('has-easysell');
  };

  // Bouton fixe d'EasySell en bas d'écran, s'il est activé dans l'application
  const visible = new Set();
  const refreshSticky = () => {
    const sticky = document.getElementById('es-sticky');
    if (sticky) sticky.classList.toggle('nl-es-hidden', visible.size > 0);
  };
  const io =
    'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
          entries.forEach((e) => (e.isIntersecting ? visible.add(e.target) : visible.delete(e.target)));
          refreshSticky();
        })
      : null;
  const watchVisibility = (el) => {
    if (!io || !el || el.dataset.nlWatched) return;
    el.dataset.nlWatched = 'true';
    io.observe(el);
  };
  const styleSticky = (sticky) => {
    keep(sticky, () => {
      Object.entries({
        ...PILL,
        left: '12px',
        right: '12px',
        width: 'auto',
        bottom: 'calc(12px + env(safe-area-inset-bottom, 0px))',
        'min-height': '3.25rem',
      }).forEach(([p, v]) => set(sticky, p, v));
      darkText(sticky);
      sticky.classList.add('nl-es');
    });
    document.body.classList.add('has-es-sticky');
    refreshSticky();
  };

  // Fenêtre de commande : arrondis, bouton d'accent, ligne de réassurance
  const styleForm = () => {
    const container = document.getElementById('es-form-container');
    if (!container) return;
    set(container, 'border-radius', '20px');
    container.querySelectorAll('.close-icon i, .close-icon svg').forEach((icon) => set(icon, 'color', '#fff'));
    const button = document.getElementById('es-form-button');
    if (!button) return;
    keep(button, () => {
      set(button, 'background-color', 'var(--color-accent)');
      set(button, 'color', 'var(--color-dark)');
      set(button, 'border-radius', '999px');
      darkText(button);
    });
    if (!container.querySelector('.nl-es-assurance')) {
      const list = document.createElement('ul');
      list.className = 'nl-es-assurance';
      list.setAttribute('role', 'list');
      const item = document.createElement('li');
      item.textContent = 'Vous payez à la livraison';
      list.appendChild(item);
      button.insertAdjacentElement('afterend', list);
    }
  };

  const scan = () => {
    document.querySelectorAll('.es-popup-button').forEach((button) => {
      if (!button.classList.contains('nl-es')) styleButton(button);
      watchVisibility(button);
    });
    watchVisibility(document.querySelector('.site-footer'));
    const sticky = document.getElementById('es-sticky');
    if (sticky && !sticky.classList.contains('nl-es')) styleSticky(sticky);
    styleForm();
  };

  const start = () => {
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
